import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const targetSelector = event.currentTarget.dataset.bsTarget || event.currentTarget.getAttribute('href')
    if (!targetSelector) return

    const target = document.querySelector(targetSelector)
    if (!target) return

    const isOpen = target.classList.contains('show')
    if (isOpen) {
      target.classList.remove('show')
      target.style.display = 'none'
    } else {
      target.classList.add('show')
      target.style.display = 'block'
    }
  }
}
